import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ExtraRouterService } from "../../../services/extra-router.service";
import { UntypedFormBuilder } from "@angular/forms";
import { FormHelperService } from "../../../services/form-helper.service";
import { ToastService } from "../../../services/toast.service";
import { LoaderService } from "../../../services/loader.service";
import { ContactService } from "../../../services/contact.service";
import { LogementService } from "../../../services/logement.service";
import { BackResourceService } from "../../../services/back-resource.service";
import { Image } from "../../../models/image";

@Component({
    selector: 'app-contact-edit',
    templateUrl: './contact-edit.component.html',
    styleUrls: ['./contact-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactEditComponent implements OnInit {

  contactId: number = null;

  image = new Image();

  form = this.fb.group({
    nom: [],
    metier: [],
    email: [],
    numeroTelephone: [],
    site: [],
    deletePhoto: [false],
  });

  constructor(private route: ActivatedRoute,
              private router: Router,
              private logementService: LogementService,
              private contactService: ContactService,
              private fb: UntypedFormBuilder,
              private fh: FormHelperService,
              private toastService: ToastService,
              public loaderService: LoaderService,
              private backResource: BackResourceService
  ) {
  }

  ngOnInit() {
    this.contactId = parseInt(this.route.snapshot.paramMap.get('id'));
    const logementId = this.logementService.getLogementCourantId();
    if (this.contactId) {
      this.contactService.findById(logementId, this.contactId).then(contact => {
        this.image = new Image(contact.photo ? (this.backResource.getUrl(contact.photo)) : null);
        this.form.patchValue(contact);
      });
    }
  }

  save() {
    const contact = this.form.getRawValue();
    contact.photo = {binaryContent: this.image.current === this.image.original ? null : this.image.file};
    const logementId = this.logementService.getLogementCourantId();
    this.contactService.save(logementId, this.contactId, contact).then((response) => {
      this.toastService.show(response.message, {classname: 'toast-' + response.status});
      if (response.status == 'error') {
        this.fh.setSymfonyFormErrors(this.form, response.errors);
      } else {
        this.router.navigate(['/contacts']);
      }
    });
  }

  updateImage(image) {
    this.form.get('deletePhoto').setValue(false);
    this.image = image;
  }

  deleteImage(image) {
    this.form.get('deletePhoto').setValue(true);
  }
}
